import axios from 'axios';
import { getUrl } from './service-utils';
import authHeader from './auth-header';

const API_URL = getUrl();

/**
 * Upload a base64 image to S3
 * @param imageBase64OrDataUrl - Base64 data URL (e.g., "data:image/png;base64,...")
 * @param bucketFolder - Optional bucket folder (default: 'appImages')
 * @returns S3 key of the uploaded image
 */
const uploadBase64Image = async (
  imageBase64OrDataUrl: string,
  bucketFolder: string = 'appImages'
): Promise<string> => {
  const res = await axios.post(
    API_URL + 'awss3/upload-base64',
    { imageBase64OrDataUrl, bucketFolder },
    { headers: authHeader() }
  );
  return res.data.data.s3Key;
};

const imageUploadService = { uploadBase64Image };

export default imageUploadService;
